<template>
  <v-container class="pa-0" >
    <v-container fluid class="pa-0" v-show="isShowingPlayer" v-motion-pop-visible>
      <v-expand-transition>
        <v-card v-if="isPlaylistVisible" dark class=" !rounded-t-xl !rounded-b-none ">
          <v-tabs v-model="playlistTab" color="#1ed760">
            <v-tab>Playlists</v-tab>
            <v-tab>Selected </v-tab>
          </v-tabs>
          <v-tabs-items v-model="playlistTab" class="!max-h-36 !overflow-auto">

            <v-tab-item>
              <v-list dark>
                <v-list-item-group color="#1ed760" v-model="listItem">
                  <v-list-item v-for="(song, index) in playlist" :key="index" @click.prevent="selected(song)">
                    <v-list-item-avatar>
                      <v-img v-if="song.images" :src="song.images[0].url"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="capitalize">
                        {{ song.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="capitalize">
                        {{ song.type }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-tab-item>
            <v-tab-item>
              <v-list dark>
                <v-list-item-group color="#1ed760" v-model="listItem">
                  <div v-if="playlist1 < 1" class="text-white flex justify-center items-center !max-h-36 capitalize">No
                    Playlist Selected</div>
                  <v-list-item v-else v-for="(song, index) in playlist1" :key="index"
                    @click.prevent="playDummy(song.track.uri, song)">
                    <v-list-item-avatar>
                      <v-img :src="song.track.album.images[0].url"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ song.track.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ song.track.artists[0].name }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-expand-transition>
      <v-card v-if="!auth" dark class="!rounded-t-none !rounded-b-xl !border-0">
        <v-card-title class="text-subtitle-1 py-1">
          <!-- <v-icon left color="green" size="35">mdi-spotify</v-icon> Spotify -->
          <v-avatar tile min-width="100">
            <v-img contain :src="require(`@/assets/img/Logo/Spotify_Logo_RGB_Green.png`)"></v-img>
          </v-avatar>
          <v-spacer></v-spacer>
          <v-btn @click="$store.dispatch('setMiniPlayerVisibility')" icon v-show="!premiumLayout">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="py-1" @click.prevent="spotifyLogin">
          <v-container fluid>
            <v-row no-gutters justify="center" align="center" class="center--text">
              <v-col>
                <v-spacer></v-spacer>
              </v-col>
              <v-col class="d-flex justify-center">
                <v-btn color="#1ed760" class="!capitalize font-sans !font-normal">
                  Sign In to
                  <v-icon color="black">mdi-spotify</v-icon>
                  spotify
                </v-btn>
              </v-col>
              <v-col>
                <v-spacer></v-spacer>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-card dark class="!rounded-t-none !rounded-b-xl" v-else>
        <v-card-title class="text-subtitle-1 py-1">
          <!-- <v-icon left color="green" size="35">mdi-spotify</v-icon>Spotify -->
          <v-avatar tile min-width="100">
            <v-img contain :src="require(`@/assets/img/Logo/Spotify_Logo_RGB_Green.png`)"></v-img>
          </v-avatar>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn @click="$store.dispatch('setMiniPlayerVisibility')" icon v-show="!premiumLayout">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="py-1">
          <v-container fluid class="!p-0 pb-2">
            <div v-if="spotifyLoading" class="!text-white text-2xl flex justify-between items-center">
              <!-- <LoadingSpinner class="bg-transparent !relative" /> -->
              <h3 class="text-lg font-Handel !grow text-center leading-10">
                Device is Connecting...
              </h3>
            </div>
            <div class="flex justify-between items-center" v-else>
              <div class="max-w-min">
                <v-avatar tile>
                  <!-- <v-img :src="currentSong ? currentSong.images[0].url : ''"> </v-img> -->
                  <v-img v-if="currentSong" :src="currentSong ? currentSong.track.album.images[0].url : ''"></v-img>

                </v-avatar>
              </div>
              <div class="w-4/5 flex flex-col  ">
                <div>
                  <div class="whitespace-nowrap px-3 overflow-hidden text-ellipsis text-center text-white">{{
                    currentSong ?
                    currentSong.track.name : `Welcome to Spotify`
                  }}</div>

                </div>
                <div class="flex items-center justify-center">
                  <div class="mx-0 px-0">
                    <v-btn @click.prevent="prevSong" icon :disabled="disablePrev">
                      <v-icon>mdi-skip-previous</v-icon>
                    </v-btn>
                  </div>
                  <div class="mx-0 px-0">
                    <v-btn @click="!isPlaying ? playDummy(currentSong.track.uri, currentSong) : pauseSong()" icon>
                      <v-icon color="#1ed760" size="30">{{
                        isPlaying ? "mdi-pause-circle" : "mdi-play-circle"
                      }}</v-icon>
                    </v-btn>
                  </div>
                  <div class="mx-0 px-0">
                    <v-btn @click="nextSong" icon :disabled="disableNext">
                      <v-icon>mdi-skip-next</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
              <div class="max-w-min">
                <v-btn @click="isPlaylistVisible = !isPlaylistVisible" icon>
                  <v-icon>{{
                    isPlaylistVisible ? "mdi-chevron-down" : "mdi-chevron-up"
                  }}</v-icon>
                </v-btn>
              </div>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>

    <v-tooltip top dark color="black">
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab dark x-large class=" !rounded-[30px] !absolute !bottom-10 !right-10 z-10 " v-bind="attrs" v-on="on"
          @click="$store.dispatch('setMiniPlayerVisibility')" v-show="!isShowingPlayer && !premiumLayout && !isMobile" elevation="5"
          color="black">
          <v-icon x-large color="#1ed760">
            mdi-spotify
          </v-icon>
        </v-btn>
      </template>
      <span :class="`${routeLink}_text_color`">Spotify</span>
    </v-tooltip>
    <SubscribePremiumDialog />
  </v-container>
</template>

<script>
import defaultMixin from "../../mixins";

import store from "@/store";
import LoadingSpinner from "@/pages/front/straight/childs/LoadingSpinner.vue";
import SubscribePremiumDialog from "../settings/SubscribePremiumDialog.vue";

export default {
  name: "MusicPlayerMini",
  data() {
    return {
      isPlaying: false,
      isPlaylistVisible: false,
      playlistTab: null,
      // isShowingPlayer: true,
      audio: new Audio(),
      currentSong: null,
      listItem: 0,
      expiry: 0,
      playlist1: [
        // {
        //   title: "Service Bell",
        //   artist: "Daniel Simion",
        //   url: "https://soundbible.com/mp3/service-bell_daniel_simion.mp3",
        //   image: "https://source.unsplash.com/crs2vlkSe98/400x400",
        // },
        // {
        //   title: "Meadowlark",
        //   artist: "Daniel Simion",
        //   url: "https://soundbible.com/mp3/meadowlark_daniel-simion.mp3",
        //   image: "https://source.unsplash.com/35bE_njbG9E/400x400",
        // },
        // {
        //   title: "Hyena Laughing",
        //   artist: "Daniel Simion",
        //   url: "https://soundbible.com/mp3/hyena-laugh_daniel-simion.mp3",
        //   image: "https://source.unsplash.com/Esax9RaEl2I/400x400",
        // },
        // {
        //   title: "Creepy Background",
        //   artist: "Daniel Simion",
        //   url: "http://soundbible.com/mp3/creepy-background-daniel_simon.mp3",
        //   image: "https://source.unsplash.com/j0g8taxHZa0/400x400",
        // },
      ],
      spotifyLoading: false,
    };
  },
  computed: {
    isShowingPlayer(){
      return this.$store.getters.SpotifyPlayerVisibility;
    },
    auth() {
      return this.$store.getters.SpotifyAccessToken;
    },
    premiumLayout() {
      return this.$store.getters.isPremiumLayout;
    },
    playlist() {
      return this.$store.getters.SpotifyPlaylist.items;
    },
    disablePrev() {
      const index = this.playlist1.indexOf(this.currentSong);
      return index === 0;
    },
    disableNext() {
      const index = this.playlist1.indexOf(this.currentSong);
      return index === this.playlist1.length - 1;
    },
    colorAsRoute() {
      if (this.routeLink == "straight") {
        return "#a07a1d";
      }
      else if (this.routeLink == "gay") {
        return "#88c3fa";
      }
      else if (this.routeLink == "lesbian") {
        return "#9e2eec";
      }
    },
  },
  watch:{
    currentSong:{
      handler(){
        this.$store.dispatch('setCurrentSong' , this.currentSong);
        console.log(this.currentSong , 'test current song');
      },
      deep: true,
    }
  },
  methods: {
    selected(item) {
      var access_token = this.$store.getters.SpotifyAccessToken;
      fetch(`${item.tracks.href}`, {
        method: "GET",
        headers: {
          "Authorization": "Bearer " + access_token,
          "Content-Type": "application/json"
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.playlist1 = data.items;
          if (this.isPlaying == false) {
            this.currentSong = this.playlist1[0];
          }
          this.playlistTab = 1;
          this.listItem = 0;
        });
    },
    getDevices() {
      var access_token = this.$store.getters.SpotifyAccessToken;
      fetch("https://api.spotify.com/v1/me/player/devices", {
        method: "GET",
        headers: {
          "Authorization": "Bearer " + access_token,
          "Content-Type": "application/json"
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
        });
    },
    pauseSong() {
      const device_id = this.$store.getters.SpotifyDeviceId;
      fetch(`https://api.spotify.com/v1/me/player/pause?device_id=${device_id}`, {
        method: "GET",
        headers: {
          "Authorization": "Bearer " + access_token,
          "Content-Type": "application/json"
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
        });
    },
    pauseSong() {
      const device_id = this.$store.getters.SpotifyDeviceId;
      var myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$store.getters.SpotifyAccessToken}`);
      myHeaders.append("Content-Type", "application/json");
      var requestOptions = {
        method: "PUT",
        headers: myHeaders,
        // body: raw,
        redirect: "follow"
      };
      try {
        fetch(`https://api.spotify.com/v1/me/player/pause?device_id=${device_id}`, requestOptions)
          .then(response => response.text())
          .then(result => { console.log(result); this.isPlaying = false; })
          .catch(error => console.log("error", error));
      }
      catch (error) {
        console.log(error);
      }
      finally {
      }
    },
    playDummy(context, item) {
      const device_id = this.$store.getters.SpotifyDeviceId;
      var myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$store.getters.SpotifyAccessToken}`);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "uris": [
          `${context}`
        ]
      });
      var requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };
      try {
        fetch(`https://api.spotify.com/v1/me/player/play?device_id=${device_id}`, requestOptions)
          .then(response => response.text())
          .then(result => { console.log(result); this.currentSong = item; this.isPlaying = true; })
          .catch(error => console.log("error", error));
      }
      catch (error) {
        console.log(error);
      }
      finally {
      }
    },
    // playSong(context, item) {
    //   var access_token = this.$store.getters.SpotifyAccessToken;
    //   // this.audio.src = this.currentSong.track.preview_url;
    //   this.currentSong = item
    //   console.log(context)
    //   // console.log(JSON.parse(localStorage.getItem('215679d1fe0ec5ce:keys_store/deviceId')))
    //   const device_id = this.$store.getters.SpotifyDeviceId
    //   // 
    //   fetch(`https://api.spotify.com/v1/me/player/play?device_id=${device_id}`, {
    //     method: "PUT",
    //     headers: {
    //       "Authorization": 'Bearer ' + access_token,
    //       'Content-Type': 'application/json',
    //       "Accept": "application/json"
    //     },
    //     data: JSON.stringify({
    //       "uris": [
    //         `${context}`
    //       ]
    //     }),
    //   })
    //     .then((response) => {
    //       if (response.ok) {
    //         return response.json();
    //       }
    //       return Promise.reject(response);
    //     })
    //     .then((data) => {
    //       this.playlist1 = data.items
    //       // this.playPause();
    //     })
    //     .catch((response) => {
    //       response.json().then((json) => {
    //         console.log(json.error.reason == "PREMIUM_REQUIRED");
    //         if (json.error.reason == "PREMIUM_REQUIRED") {
    //           this.$store.dispatch("errorAction", 'Need Premium Spotify Account', {
    //             root: true,
    //           });
    //         }
    //       })
    //     });
    // },
    prevSong() {
      const index = this.playlist1.indexOf(this.currentSong);
      if (index > 0) {
        this.currentSong = this.playlist1[index - 1];
        this.playDummy(this.currentSong.track.uri, this.currentSong);
        this.listItem = index - 1;
      }
    },
    nextSong() {
      const index = this.playlist1.indexOf(this.currentSong);
      if (index < this.playlist1.length - 1) {
        this.currentSong = this.playlist1[index + 1];
        this.playDummy(this.currentSong.track.uri, this.currentSong);
        this.listItem = index + 1;
      }
    },
    // playPause() {
    //   if (this.currentSong) {
    //     this.isPlaying = !this.isPlaying;
    //     if (this.isPlaying) {
    //       this.audio.play();
    //     } else {
    //       this.audio.pause();
    //     }
    //   } else {
    //     this.currentSong = this.playlist1[0];
    //     this.audio.src = this.currentSong.track.preview_url;
    //     this.audio.play();
    //     this.isPlaying = true;
    //   }
    //   const index = this.playlist1.indexOf(this.currentSong);
    //   this.listItem = index;
    // },
    isActiveSong(song) {
      const index = this.playlist1.indexOf(song);
      return index === this.playlist1.indexOf(this.currentSong);
    },
    changeSong(song) {
      this.currentSong = song;
      this.audio.src = this.currentSong.track.preview_url;
      this.audio.play();
      this.isPlaying = true;
      const index = this.playlist1.indexOf(song);
      this.listItem = index;
    },
    generateRandomString(length) {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },
    spotifyLogin() {
      var client_id = `d15809a9d96545ca99ffcc13e8c81832`;
      // console.log("" , `${process.env.VUE_SPOTIFY_CLIENT_ID}`)
      var data = this.$store.getters.StateUser.data.account_type || JSON.parse(localStorage.getItem("userInfo")).data.account_type;
      if (data !== null) {
        const types = {
          "1": "lesbian",
          "2": "gay",
          "3": "straight",
        };
        const type = types[data];
        // var redirect_uri = `https://magnum-xl.netlify.app/${type}/profiles`;
        // var redirect_uri = `http://localhost:8080/${type}/profiles`;
        var redirect_uri = `${process.env.VUE_APP_SPOTIFY_URL}${type}/profiles`;
        console.log(`${process.env.VUE_APP_SPOTIFY_URL}${type}/profiles` , 'checkRedirect')
      }
      var state = this.generateRandomString(16);
      var stateKey = "spotify_auth_state";
      localStorage.setItem(stateKey, state);
      var scope = "user-read-private user-read-email playlist-read-private user-read-recently-played user-modify-playback-state streaming user-read-currently-playing user-read-playback-state ";
      var url = "https://accounts.spotify.com/authorize";
      url += "?response_type=token";
      url += "&client_id=" + encodeURIComponent(client_id);
      url += "&scope=" + encodeURIComponent(scope);
      url += "&redirect_uri=" + encodeURIComponent(redirect_uri);
      url += "&state=" + encodeURIComponent(state);
      window.location = url;
      this.setTEst();
    },
    waitForSpotifyWebPlaybackSDKToLoad: async function () {
      return new Promise(resolve => {
        if (window.Spotify) {
          resolve(window.Spotify)
        } else {
          window.onSpotifyWebPlaybackSDKReady = () => {
            resolve(window.Spotify)
          }
        }
      })
    },




    setTEst: async function () {
      this.spotifyLoading = true;
      const { Player } = await this.waitForSpotifyWebPlaybackSDKToLoad()
      const token = this.$store.getters.SpotifyAccessToken;
      if (token) {
        console.log("spotify device connecting")
        const sdk = new Player({
          name: 'Magnum XL',
          volume: 1.0,
          getOAuthToken: callback => { callback(token) }
        })
        console.log(JSON.stringify(sdk))
        // Error handling
        sdk.addListener('initialization_error', ({ message }) => { console.log('Initialization_error: ' + message) })
        sdk.addListener('authentication_error', ({ message }) => { console.log('Authentication_error: ' + message) })
        sdk.addListener('account_error', ({ message }) => { console.log('Account_error: ' + message) })
        sdk.addListener('playback_error', ({ message }) => { console.log('Playback_error: ' + message) })
        // Playback status updates
        sdk.addListener('player_state_changed', state => {
          // Update UI information on player state changed
        })
        // Ready
        sdk.addListener('ready', ({ device_id }) => {
          this.spotifyLoading = false;
          console.log('Ready with Device Id: ', device_id)
          this.$store.dispatch("setSpotifyDeviceId", device_id);

        })
        // Not Ready
        sdk.addListener('not_ready', ({ deviceId }) => {
          console.log('Not ready with device Id: ', deviceId)
        })
        sdk.connect()
      }

      // this.spotifyLoading = false;
    },
    // window.onSpotifyWebPlaybackSDKReady = () => {
    //   const token = this.$store.getters.SpotifyAccessToken;
    //   const player = new Spotify.Player({
    //     name: "Magnum-XL",
    //     getOAuthToken: cb => { cb(token); },
    //     volume: 1
    //   }); // Ready
    //   player.addListener("ready", ({ device_id }) => {
    //     console.log("Ready with Device ID", device_id);
    //     this.$store.dispatch("setSpotifyDeviceId", device_id);
    //     this.spotifyLoading = false;
    //   });
    //   // Not Ready
    //   player.addListener("not_ready", ({ device_id }) => {
    //     console.log("Device ID has gone offline", device_id);
    //     this.spotifyLoading = false;
    //   });
    //   player.addListener("initialization_error", ({ message }) => {
    //     console.error(message);
    //     this.spotifyLoading = false;
    //   });
    //   player.addListener("authentication_error", ({ message }) => {
    //     console.error(message);
    //     this.spotifyLoading = false;
    //   });
    //   player.addListener("account_error", ({ message }) => {
    //     console.error(message);
    //     this.spotifyLoading = false;
    //   });
    //   player.connect();
    // };




    testHash() {
      this.getHashParams();
      this.testhas();
    },
    testhas() {
      // var params = this.getHashParams();
      var access_token = this.$store.getters.SpotifyAccessToken;
      var state = this.$store.getters.SpotifyState;
      var stateKey = "spotify_auth_state";
      var storedState = localStorage.getItem("spotify_auth_state");
      if (access_token && (state == null)) {
        console.log(access_token, "state", state, "stored");
        alert("There was an error during the authentication");
      }
      else {
        if (access_token) {
          fetch("https://api.spotify.com/v1/me", {
            method: "GET",
            headers: {
              "Authorization": "Bearer " + access_token,
              "Content-Type": "application/json"
            },
          })
            .then((response) => response.json())
            .then((data) => this.$store.dispatch("setSpotifyUser", data));
          if (this.$store.getters.SpotifyUser.product == "premium") {
            fetch("https://api.spotify.com/v1/me/playlists", {
              method: "GET",
              headers: {
                "Authorization": "Bearer " + access_token,
                "Content-Type": "application/json"
              },
            })
              .then((response) => response.json())
              .then((data) => this.$store.dispatch("setSpotifyPlaylist", data));
          }
        }
        else {
          console.log("Login failed");
        }
      }
    },
    tokenReset() {
      setTimeout(function () {
        // store.dispatch("setSpotifyToken", null);
      }, this.expiry * 1000);
    },
    getHashParams() {
      var hashParams = {};
      var e, r = /([^&;=]+)=?([^&;]*)/g, q = window.location.hash.substring(1);
      while (e = r.exec(q)) {
        hashParams[e[1]] = decodeURIComponent(e[2]);
      }
      if (hashParams.access_token) {

        console.log("test spotify", hashParams);
        this.$store.dispatch("setSpotifyToken", hashParams.access_token);
        this.$store.dispatch("setSpotifyState", hashParams.state);
        console.log("access token : ", hashParams.access_token);
        this.expiry = hashParams.expires_in;
        this.tokenReset();
        console.log("Something went wrong", hashParams);
      }

    }
  },

  created() {
    this.testHash();


    var access_token = this.$store.getters.SpotifyAccessToken;
    if (access_token) {
      fetch("https://api.spotify.com/v1/me", {
        method: "GET",
        headers: {
          "Authorization": "Bearer " + access_token,
          "Content-Type": "application/json"
        },
      })
        .then((response) => response.json())
        .then((data) => this.$store.dispatch("setSpotifyUser", data));
      fetch("https://api.spotify.com/v1/me/playlists", {
        method: "GET",
        headers: {
          "Authorization": "Bearer " + access_token,
          "Content-Type": "application/json"
        },
      })
        .then((response) => response.json())
        .then((data) => this.$store.dispatch("setSpotifyPlaylist", data));
    }
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "setSpotifyToken") {
        this.setTEst();
      }
      if (mutation.type == "setSpotifyPlaylist") {
        this.selected(mutation.payload.items[0]);
        // console.log('spotify play list' , mutation.payload.items[0])
      }
    });
    // this.setTEst();
    if (!this.$store.getters.SpotifyDeviceId && localStorage.getItem("spotify_token")) {
      console.log(!this.$store.getters.SpotifyDeviceId && !localStorage.getItem("spotify_token"), "test");
    }
    else {
      JSON.parse(localStorage.getItem("spotify_deviceID")) ? this.$store.commit("setSpotifyDeviceId", JSON.parse(localStorage.getItem("spotify_deviceID"))) : null;
    }
    // this.$nextTick(() => {
    //   this.audio.addEventListener("ended", () => {
    //     this.nextSong();
    //   });
    // });
  },
  beforeMount() {
  },
  mounted() {
    this.setTEst();
    // document.addEventListener("click", () => {
    // this.setTEst();
    // // console.log(this.userInteraction, "test ...");
    // });
  },
  components: { LoadingSpinner, SubscribePremiumDialog }
};
</script>

<style  scoped>
.color {
  /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
  background: rgb(177, 145, 65);
  background: linear-gradient(345deg,
      rgb(171 139 53) 0%,
      rgba(202, 174, 112, 1) 53%,
      rgb(140 108 24) 100%)
}

.straight_text_color {

  color: #a07a1d;
}

.gay_text_color {
  color: #88c3fa;
}

.lesbian_text_color {
  color: #9e2eec;
}
</style>
